import { SxProps } from "@mui/material";
import colors from "../../theme/Colours";

export const getContainerStyle = (isMobile: boolean): SxProps => ({
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "space-evenly",
  alignItems: isMobile ? "center" : "flex-start",
  padding: isMobile ? "24px" : "48px",
  gap: isMobile ? 4 : 0,
});

export const getLeftSectionStyle = (isMobile: boolean): SxProps => ({
  width: isMobile ? "100%" : "35%",
});

export const getRightSectionStyle = (isMobile: boolean): SxProps => ({
  width: isMobile ? "100%" : "33%",
});

export const toggleButtonStyle = {
  display: "flex",
  marginBottom: "24px",
  borderRadius: "6px",
  overflow: "hidden",
  border: `1px solid ${colors.primaryButtonOrange}`,
  width: "326px",
  height: "36px",
  borderRight: "none",
};

export const getToggleButtonStyle = (isActive: boolean) => ({
  flex: 1,
  height: "100%",
  backgroundColor: isActive ? colors.primaryButtonOrange : "transparent",
  color: isActive ? colors.background2 : colors.buttonBGColor,
  borderRight: `1px solid ${colors.buttonBgColor}`,
  cursor: "pointer",
  fontWeight: isActive ? 500 : 400,
  fontSize: "16px",
  textTransform: "none" as const,
  borderRadius: "0px",
  padding: 0,
  "&:hover": {
    backgroundColor: isActive ? colors.primaryButtonOrange : colors.buttonBG2,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const getToggleHeadingStyle = (isMobile: boolean): SxProps => ({
  fontWeight: 600,
  fontSize: isMobile ? "16px" : "20px",
  paddingBottom: "8px",
});

export const getHeadingStyle = (isMobile: boolean): SxProps => ({
  fontWeight: 600,
  fontSize: isMobile ? "24px" : "32px",
  paddingBottom: "8px",
});

export const getSubTextStyle = (isMobile: boolean): SxProps => ({
  fontSize: isMobile ? "14px" : "16px",
  paddingBottom: "40px",
  color: colors.subTextColor,
});

export const getPromoTextStyle = (isMobile: boolean): SxProps => ({
  mb: 4,
  fontWeight: 600,
  fontSize: isMobile ? "24px" : "28px",
  letterSpacing: "1.5px",
});

export const rememberMeContainer: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "16px",
  marginBottom: "32px",
};

export const checkbox: SxProps = {
  "&.Mui-checked": {
    color: colors.primaryButtonOrange,
  },
};

export const rememberMeLabel = (isMobile: boolean): SxProps => ({
  fontSize: isMobile ? "12px" : "14px",
  color: colors.buttonBGColor,
});

export const forgotPassword = (isMobile: boolean): React.CSSProperties => ({
  fontSize: isMobile ? "10px" : "14px",
  color: colors.primaryButtonOrange,
  textDecoration: "none",
  fontWeight: 500,
});
